import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageCreateProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageCreateProjectController.php:23
* @route '/product-page/{product}/ai-project'
*/
const AiProductPageCreateProjectController = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AiProductPageCreateProjectController.url(args, options),
    method: 'post',
})

AiProductPageCreateProjectController.definition = {
    methods: ["post"],
    url: '/product-page/{product}/ai-project',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageCreateProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageCreateProjectController.php:23
* @route '/product-page/{product}/ai-project'
*/
AiProductPageCreateProjectController.url = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { product: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'sku' in args) {
        args = { product: args.sku }
    }

    if (Array.isArray(args)) {
        args = {
            product: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        product: typeof args.product === 'object'
        ? args.product.sku
        : args.product,
    }

    return AiProductPageCreateProjectController.definition.url
            .replace('{product}', parsedArgs.product.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageCreateProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageCreateProjectController.php:23
* @route '/product-page/{product}/ai-project'
*/
AiProductPageCreateProjectController.post = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AiProductPageCreateProjectController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageCreateProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageCreateProjectController.php:23
* @route '/product-page/{product}/ai-project'
*/
const AiProductPageCreateProjectControllerForm = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: AiProductPageCreateProjectController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\AiProductPageCreateProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/AiProductPageCreateProjectController.php:23
* @route '/product-page/{product}/ai-project'
*/
AiProductPageCreateProjectControllerForm.post = (args: { product: string | number | { sku: string | number } } | [product: string | number | { sku: string | number } ] | string | number | { sku: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: AiProductPageCreateProjectController.url(args, options),
    method: 'post',
})

AiProductPageCreateProjectController.form = AiProductPageCreateProjectControllerForm

export default AiProductPageCreateProjectController